import React, { Component } from 'react';
import { Modal, Button, Divider } from 'antd';
import SignUpForm from './SignUpForm.js';
import BtnLogin from '../Buttons/BtnLogin';
import googleLogo from '../../images/google-g-logo.svg';

class SignUp extends Component {

  constructor(props){
    super(props);

    this.state = { visible: false }
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  }

  render() {
    return (
      <div>
        <span onClick={this.showModal}>
          {this.props.children}
        </span>
        <Modal
          title="Sign-Up"
          width='350px'
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={
            <Button key="cancel" size="large" onClick={this.handleCancel}>Cancel</Button>
          }
        >
          <h3 className="login-heading">All Features Completely Free!</h3>
          <SignUpForm fetchUser={this.props.fetchUser}/>
          <Divider />
          <a href="/auth/google">
            <BtnLogin btnKey="google" src={googleLogo} alt="google">
            Sign up with Google
          </BtnLogin></a>
        </Modal>
      </div>
    );
  }
}


export default SignUp;



// WEBPACK FOOTER //
// ./src/components/Site/SignUp.js